import React, { useContext, useState ,useRef} from "react";
import { Dropdown, DropdownOption, Icon } from "@abb/abb-common-ux-react";
import { RootContext } from "../../../contexts/root-context";

function NzDropdownPowerFlow() {
  const { setPowerFlowSelectedOption } = useContext(RootContext);
  const powerDeviceNameListWithGroups = [
    "Solar Generated Power",
    "Utility Incoming Power",
    "HVAC Demand Power",
    "EV Chargers Demand Power",
    "HVAC_2N",
    "LOADS_NORD",
    "HVAC_GN",
    "HVAC_2S",
    "MAIN_QG1",
    "MAIN_QG2",
    "HVAC_1N",
    "HVAC_GS",
    "SOLAR_ROOF",
    "HVAC_3N",
    "MAIN_QG3",
    "HVAC_3S",
    "MAIN_QG4",
    "HVAC_1S",
    "EV1",
  ];

  // Initialize options state with powerDeviceNameListWithGroups
  const [options] = useState(
    powerDeviceNameListWithGroups.map((label, i) => ({
      label: label,
      value: i,
    }))
  );

  const [selectedMulti, setSelectedMulti] = useState([options[0]]);
  const dropdownRef = useRef(null);
  const commonFlags = {
    allowAdd: false,
    clearable: true,
    searchable: true,
    clearOnEscape: true,
    sizeClass: "small",
  };

  const getMenuItemTemplate = (o) => (
    <span
      style={{
        flex: 1,
        // padding: "16px",
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        
      
      }}
    >
      <div style={{ display: "flex", flexDirection: "column" }}>
        <span>{o.label}</span>
      </div>
    </span>
  );

  const getSelectedItemTemplate = (o) => (
    <span
      style={{
        // padding: "16px",
        display: "flex",
        alignItems: "center",
      }}
    >
      {o.label}
    </span>
  );

  const handleDropdownChangeMulti = (selectedValues) => {
    setSelectedMulti(selectedValues);
    setPowerFlowSelectedOption(selectedValues.map((obj) => obj.label));
  };

  return (
    <div >
      <div 
        ref={dropdownRef} 
        style={{ 
          position: "absolute", 
          zIndex: 1001, 
          width: "200px", 
          marginTop: "10px"
        }}
      >
        <Dropdown
          placeholder="Select a Device"
          multiselect={true}
          value={selectedMulti}
          onChange={handleDropdownChangeMulti}
          {...commonFlags}
          style={{
            control: (baseStyle, state) => ({
              ...baseStyle,
              border: "1px solid #ccc",
              borderRadius: "4px",
              boxShadow: state.isFocused ? "0 0 0 1px blue" : null,
              '& .abb-dropdown-control': {
                paddingRight: '8px', // Adjust padding as needed
              },
              '& .abb-dropdown-indicator': {
                display: 'none', // Hide the dropdown arrow
              },
              '& .abb-dropdown-placeholder': {
                color: '#999', // Placeholder color
              },
            }),
          }}
        >
          {options.map((o) => (
            <DropdownOption
              key={o.value}
              label={o.label}
              value={o.value}
              disabled={o.disabled}
              menuItemTemplate={getMenuItemTemplate(o)}
              selectedItemTemplate={getSelectedItemTemplate(o)}
            />
          ))}
        </Dropdown>
      </div>
    
    </div>

  );
}

export default NzDropdownPowerFlow;

